import { createModel } from "@rematch/core";
import { client } from "../shared/apiClient";
import { IApiResponseError } from "../shared/dto/IErrorDto";
import i18next from "i18next";

const auditions = createModel({
  state: {
    loading: false as boolean,
  },
  reducers: {
    setLoading: (state: any, loading: boolean) => ({
      ...state,
      loading,
    }),
  },
  effects: (dispatch: any) => ({
    async patchAuditionSwap(
      { draggeddAudSchedId, pushedAudSchedId },
      state
    ) {
      await client.api.auditions
        .patchAuditionSwap(draggeddAudSchedId, pushedAudSchedId)
        .then((resp: any) => {})
        .catch((resp: any) => {
          onErrorRedirect(resp);
          let respError: IApiResponseError = resp.response.data;
          if (respError.error) {
            dispatch.alert.showAlert("error", respError);
          }
        });
    },
    async patchMoveAuditionTime(
      { draggeddAudSchedId, pushedAudSchedId },
      state
    ) {
      await client.api.auditions
        .patchMoveAuditionTime(draggeddAudSchedId, pushedAudSchedId)
        .then((resp: any) => {})
        .catch((resp: any) => {
          onErrorRedirect(resp);
          let respError: IApiResponseError = resp.response.data;
          if (respError.error) {
            dispatch.alert.showAlert("error", respError);
          }
        });
    },
    async patchMoveAuditionOrder(
      { draggeddAudSchedId, pushedAudSchedId, isDraggedUp },
      state
    ) {
      await client.api.auditions
        .patchMoveAuditionOrder(draggeddAudSchedId, pushedAudSchedId, isDraggedUp)
        .then((resp: any) => {})
        .catch((resp: any) => {
          onErrorRedirect(resp);
          let respError: IApiResponseError = resp.response.data;
          if (respError.error) {
            dispatch.alert.showAlert("error", respError);
          }
        });
    },
    async updateAuditionsStartOrder({ scheduleId, audStartNumber }, state) {
      dispatch.kiosk.setLoading(true);
      await client.api.auditions
        .updateAuditionsStartOrder(scheduleId, audStartNumber)
        .then((resp: any) => {
          dispatch.kiosk.setLoading(false);
        })
        .catch((resp: any) => {
          onErrorRedirect(resp);
          let respError: IApiResponseError = resp.response.data;
          if (respError.error) {
            dispatch.alert.showAlert("error", respError);
          }
          dispatch.kiosk.setLoading(false);
          throw respError;
        });
    },
    async sendAuditionTimeChanges(resendDetails) {
      dispatch.kiosk.setLoading(true);
      try {
        const response = await client.api.auditions.sendAuditionTimeChanges(
          resendDetails
        );
        if (
          response.data &&
          response.data.reports &&
          response.data.reports.length > 0
        ) {
          const failedEmails = getFailedEmailsOnItemSend(response.data.reports);
          if (failedEmails.length > 0) {
            dispatch.kiosk.setFailedEmailsList(failedEmails);
            return false;
          } else {
            return true;
          }
        } else {
          dispatch.alert.showAlert(
            "error",
            i18next.t("Error! No emails were sent.")
          );
        }
      } catch (e) {
        onErrorRedirect(e);
      } finally {
        dispatch.kiosk.setLoading(false);
      }
    },
  }),
});

export default auditions;

const onErrorRedirect = (resp: any) => {
  if (!resp.response || resp.response.status === 500) {
    window.location.replace(`${client.api.paths.redirect500}`);
  } else if (resp.response.status === 401 || resp.response.status === 403) {
    window.location.replace(`${client.api.paths.redirect403}`);
  }
};

const getFailedEmailsOnItemSend = (reports: any) => {
  return reports
    .filter((report: any) => !report.success)
    .map((email: any) => ({
      name: email.actorFullName,
      emails: email.results.map(({ email }: any) => email),
    }));
};
